import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { ReportOfficeInventoryConstants } from './report-office-inventory.constants';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { OfficeInventoryMenuEnum } from './report-office-inventory.enum';
import { ReportOfficeInventoryService } from './report-office-inventory.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import moment from 'moment';
import { ReportService } from 'src/app/reports/services/report.service';
import { StoreService } from 'src/app/common/services/store.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { UnitTypeEnum } from '../../models/unit-type-enum';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-report-office-inventory',
  templateUrl: './report-office-inventory.component.html',
  styleUrls: ['./report-office-inventory.component.scss']
})
export class ReportOfficeInventoryComponent {
  @Input() params: any;
  overViewMenu: any = ReportOfficeInventoryConstants.overViewMenu;
  officeInventoryMenuEnum = OfficeInventoryMenuEnum;
  chartView = ReportsChartEnum;
  UnitTypeEnum = UnitTypeEnum;

  currentScroll: any = '';
  placeName = '';
  CurrencyCode: string = '';
  // officeRentOption: string = 'officeRentOption';
  moreText: any;
  langName: any;
  overviewLoading = false;
  overviewGraphLoading = false;
  supplyChartLoading = false;
  isFirstTime = true;
  isChart = true;

  neighborhoodCount: number = 0;
  neighborhoodLoading: boolean = false;
  neighborhoodData: any = [];

  propertiesCount: number = 0;
  propertiesLoading: boolean = false;
  propertiesTableData: any = [];

  overviewData: any = {};
  openMarketData: any = {};
  captiveOfficeData: any = {};
  overviewChartData: any = {};
  selectedChartValue: any[] = [];
  retailRentalChartReport: any[] = [];

  neighborhoodColumns = ReportOfficeInventoryConstants.neighborhoodColumns;
  neighborhoodExpandColumns = ReportOfficeInventoryConstants.neighborhoodExpandColumns;
  propertiesColumns = ReportOfficeInventoryConstants.propertiesColumns;
  propertyTypeDropdown = ReportOfficeInventoryConstants.propertyTypeDropdown;

  userInfo: any = 0;
  placeCode: string = '';
  tableName: unknown;
  developed_properties = 37000;
  under_construction_properties = 5000;
  downloadLoading: any = {
    a: false,
    b: false
  };
  // supplyIncrementalData: any[] = [
  //   { year: "2023", rate: 10000,},
  //   { year: "2024", rate: 20000 ,},
  //   { year: "2025", rate: 40000,},
  //   { year: "2026", rate: 30000,},
  //   { year: "2027", rate: 50000, }
  // ];
  yearWiseSelectedGrade = new FormControl();
  paramGrade: string = '';
  overviewWaterfallChart: any[] = [];
  supplyIncrementalData: any[] = []
  supplyIncrementalDropdown: any[] = []
  private destroy$ = new Subject<void>(); // Subject to trigger unsubscribe
  propertyTypeValue:string = 'property_grade';
  retailRentalChartReportArray: any = [];
  constructor(
    private sharedService: SharedService,
    private officeService: ReportOfficeInventoryService,
    public reportService: ReportService,
    private storeService: StoreService,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
    public translate: TranslateService
  ) {
    this.sharedService.language$.subscribe(lang => {
      this.langName = lang;
      if (lang && !this.isFirstTime) {
        this.getReports();
        this.isChart = false;
      }
    })
    //Update Column Monthly/Annual
    if (this.sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      const columnsToUpdate = [
        { header: 'avg_office_lease_rate', columnName: 'reports.avgAnnualOfficeLeaseRate' },
        { header: 'avg_retail_lease_rate', columnName: 'reports.avgAnnualRetailLeaseRate' },
        // { header: 'averageOtherCommercialLeaseRate', columnName: 'reports.averageAnnualOtherCommercialLeaseRate' }
      ];
      // Neighborhood Table
      columnsToUpdate.forEach(column => {
        const targetColumn = this.neighborhoodColumns.find(x => x.header === column.header);
        if (targetColumn) {
          targetColumn.columnName = column.columnName;
        }
      });
      // Neighborhood Table
      const columnsToUpdateProperties = [
        { header: 'average_office_lease_rate', columnName: 'reports.avgAnnualOfficeLeaseRate' },
        { header: 'average_retail_lease_rate', columnName: 'reports.avgAnnualRetailLeaseRate' },
        { header: 'average_other_commercial_space_lease_rate', columnName: 'reports.averageAnnualOtherCommercialSpaceLeaseRate' }
      ];
      columnsToUpdateProperties.forEach(column => {
        const targetColumn = this.propertiesColumns.find(x => x.header === column.header);
        if (targetColumn) {
          targetColumn.columnName = column.columnName;
        }
      });
    }
  }
  ngOnInit() {
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.placeName = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName);
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.getReports();
    this.isFirstTime = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['params'].currentValue.property_grade) {
      this.paramGrade = changes['params'].currentValue.property_grade;
    } else {
      this.paramGrade = '';
    }

    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      this.officeService.neighborhoodPayload.pageNumber=0;
      this.officeService.propertiesPayload.pageNumber=0;
      this.propertiesCount=0;
      this.neighborhoodCount=0;
      this.getReports();
    }
  }
  lastClickedTable(event: Event, table: any) {
    this.tableName = table
  }
  /**
   * All Rports api call
  */
  getReports() {
    this.destroy$.next();
    this.getOverview();
    this.getOverviewGraph();
    this.yearWiseSupplyChart();
    this.getNeighborhoodData();
    this.getPropertiesData();
  }
  /**
   * Overview all type Data
   */
  getOverview() {
    this.overviewLoading = true;
    this.officeService.getOverview()
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              this.overviewData = res.data;
              this.overviewData['untillDate'] = this.overviewData.as_of_date ? moment.utc(this.overviewData.as_of_date).local().format('DD MMM YYYY') : null;
            }
            this.overviewLoading = false;
          },
          error: (error: any) => {
            this.overviewLoading = false;
          }
        }
      )
  }
  /**
   * WaterFall Year Chart
   */
  yearWiseSupplyChart() {
    this.supplyChartLoading = true;
    this.officeService.getYearWiseSupplyChart()
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            this.supplyChartLoading = false;
            if (res.status === 200) {
              this.supplyIncrementalData = res.data;
              
              const gradeData = this.supplyIncrementalData.map(x => x.property_grade_label);
              this.supplyIncrementalDropdown = this.sharedService.sortGrades(gradeData);

              const gradeObj = this.supplyIncrementalData.find(x => x.property_grade_label === this.supplyIncrementalDropdown[0]);
             
              this.yearWiseSelectedGrade.setValue(this.supplyIncrementalDropdown[0]);
              this.overviewWaterfallChart = gradeObj.years;


              // if (this.paramGrade) {
              //   const gradeArr = this.paramGrade.split(',');
              //   if (gradeArr.length === 1) {
              //     const grade = this.supplyIncrementalData.find(x => x.property_grade === gradeArr[0]);
              //     this.yearWiseSelectedGrade.setValue(grade || this.supplyIncrementalData[0]);
              //     this.overviewWaterfallChart = grade?.years || this.supplyIncrementalData[0].years;
              //   } else {
              //     this.yearWiseSelectedGrade.setValue(this.supplyIncrementalData[0]);
              //     this.overviewWaterfallChart = this.supplyIncrementalData[0].years;
              //   }
              // } else {
              // }
            } else {
              this.supplyIncrementalData = [];
              this.overviewWaterfallChart = [];
            }
          },
          error: (error: any) => {
            this.supplyChartLoading = false;
            this.supplyIncrementalData = [];
            this.overviewWaterfallChart = [];
          }
        }
      )
  }
  gradeSelect(e: any) {
    const gradeObj = this.supplyIncrementalData.find(x => x.property_grade_label === e.value);
    this.overviewWaterfallChart = gradeObj.years;
  }
  /**
   * Residential Units - Grade wise
   */
  getNeighborhoodData() {
    this.neighborhoodLoading = true;
    this.officeService.neighborhoodPayload['condition'] = this.propertyTypeValue;
    this.officeService.getNeighborhood(this.officeService.neighborhoodPayload)
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            this.neighborhoodData = this.reportService.setTableDataSource(res.data);
            if (this.officeService.neighborhoodPayload.pageNumber == 0) {
              this.neighborhoodCount = res.count;
            }
            this.neighborhoodLoading = false;
          },
          error: (error: any) => {
            this.neighborhoodData = [];
            this.neighborhoodCount = 0;
            this.neighborhoodLoading = false;
          }

        }
      )
  }
  /**
   * Unit Rental Transaction
   */
  getPropertiesData() {
    this.propertiesLoading = true;
    this.officeService.getProperties(this.officeService.propertiesPayload)
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            this.propertiesTableData = res.data;
            if (this.officeService.propertiesPayload.pageNumber == 0) {
              this.propertiesCount = res.count;
            }
            this.propertiesLoading = false;
          },
          error: (error: any) => {
            this.propertiesTableData = [];
            this.propertiesCount = 0;
            this.propertiesLoading = false;
          }

        }
      )
  }
  /**
   * Overview year chart
   */
  getOverviewGraph() {
    this.overviewGraphLoading = true;
    this.officeService.getOverviewGraph()
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.overviewChartData = res.data;
            
            const keyGroups = this.sharedService.sortGrades(Object.keys(this.overviewChartData)); 
              this.selectedChartValue = keyGroups.slice(0, 3);

            // Transform the data
            Object.keys(this.overviewChartData).forEach((key) => {
              let data = this.overviewChartData[key];
              this.overviewChartData[key] = data.map((obj: any) => ({
                category: obj.year.toString(),
                value: obj.area,
                name: key
              }));
            });
            // Update the retail rental chart report
            this.retailRentalChartReport = Object.keys(this.overviewChartData)
              .filter(key => this.selectedChartValue.includes(key))
              .reduce((obj: any, key: any) => {
                obj[key] = this.overviewChartData[key];
                return obj;
              }, {});
            this.retailRentalChartReportArray = this.sharedService.sortObjectByGrades(this.retailRentalChartReport)
            setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
            this.cdr.detectChanges();
          } else {
            this.retailRentalChartReport=[];
            this.overviewChartData = null;
          }
          this.overviewGraphLoading = false;
        },
        error: (error: any) => {
          this.retailRentalChartReport=[];
          this.overviewGraphLoading = false;
          this.overviewChartData = null;
        }
      });
  }
  getReportKeys(): string[] {
    if (this.overviewChartData) {
      let data = Object.keys(this.overviewChartData);
      return this.sharedService.sortGrades(data)
    }
    return [];
  }
  /**
   *
   * @param e
   * @param value
   * @returns
   * On clicking the dropdown, the chart will be added or removed
   */
  selectChart(e: any, value: any) {
    let data = this.reportService.selectChart(
      this.selectedChartValue,
      this.overviewChartData,
      e,
      value
    );
    if (data) this.retailRentalChartReportArray = this.sharedService.sortObjectByGrades(data);
    this.overviewGraphLoading = false;
    setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
  }
  selectedYear(data: any) {
    if (data.reportType === 'neighborhood') {
      this.officeService.neighborhoodPayload.pageNumber = 0;
      this.officeService.neighborhoodPayload.year = data.year;
      this.getNeighborhoodData();
    } else {
      this.officeService.propertiesPayload.pageNumber = 0;
      this.officeService.propertiesPayload.year = data.year;
      this.getPropertiesData();
    }
  }
  /**
   *
   * @param menu
   * if click menu scroll particular div
   */
  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }
  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }
  onPageEvent(e: any, report: any) {
    if (e.previousPageIndex !== e.pageIndex) {
      if (report === this.officeInventoryMenuEnum.neighborhood) {
        this.officeService.neighborhoodPayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getNeighborhoodData();
      } else {
        this.officeService.propertiesPayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getPropertiesData();
      }
    }
  }
  sortData(event: any, report: any) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    if (report === this.officeInventoryMenuEnum.neighborhood) {
      this.officeService.neighborhoodPayload.pageNumber = 0;
      this.officeService.neighborhoodPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getNeighborhoodData();
    } else {
      this.officeService.propertiesPayload.pageNumber = 0;
      this.officeService.propertiesPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getPropertiesData();
    }
  }
  downloadExcel(event: any, type: string, key: any) {
    this.downloadRentalReport(type, key);
  }
  downloadRentalReport(type: string, key: any) {
    this.downloadLoading[key] = true;
    let propertyType: string = '';
    if(key == 'a'){
      propertyType = this.propertyTypeValue;
    }
    this.officeService.downloadOfficeReport(type, this.userInfo?.user_id, propertyType).subscribe(
      {
        next: (res: any) => {
          this.downloadLoading[key] = false;
          if (res.status === 200) {
            const downloadUrl = `${this.sharedService.downloadExcelPath()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=office_inventory`;
            this.sharedService.downloadExcelUrl(downloadUrl);
            this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));

          } else {
            this.alertService.warn(res.message)
          }
        },
        error: (error: any) => {
          this.downloadLoading[key] = false;
        }
      }
    )
  }
  dropDownChange(e:any){
    this.propertyTypeValue = e;
    this.getNeighborhoodData();
  }
  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  ngOnDestroy() {
    this.destroy$.next(); // Emit signal to unsubscribe
    this.destroy$.complete(); // Clean up the Subject
  }
}

